import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {Link, useSearchParams} from "react-router-dom";
import {Pagination} from "page/util/Pagination";
import {formatDate} from "../util/helpers";
import {toast} from "react-toastify";

export default function InsightHidden() {
    const [pager, setPager] = useState();
    const [results, setResults] = useState([]);

    const [searchParams, setSearchParams] = useSearchParams();

    const page = searchParams.get("page") || "1";
    const insightId = searchParams.get("insightId") || "";
    const memberId = searchParams.get("memberId") || "";

    const requestData = () => {
        const params = {page};
        if (insightId) params.insightId = insightId;
        if (memberId) params.memberId = memberId;

        axios.get(`/admin/v1/insight/hides`, {params})
            .then((res) => {
                setPager(res.data);
                setResults(res.data.content || []);
            });
    };

    const setPage = (value) => {
        searchParams.set("page", value);
        setSearchParams(searchParams);
    };

    const search = () => {
        setPage(1);
        requestData();
    };

    useEffect(() => {
        requestData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, insightId, memberId]);

    const removeHide = (hideId) => {
        if (!window.confirm("숨김 처리를 해제하시겠습니까?")) {
            return;
        }
        axios.delete(`/admin/v1/insight/hides/${hideId}`)
            .then(() => {
                toast.success("숨김 처리가 해제되었습니다.");
                requestData();
            });
    };

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: "0px"}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">콘텐츠관리 &gt; 숨김 게시글</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-tools" style={{marginTop: "40px"}}>
                                            <div className="form-group row" style={{float: "right"}}>
                                                <label className="col-sm-auto col-form-label" style={{marginLeft: "10px"}}>게시글 ID</label>
                                                <input
                                                    type="text"
                                                    className="form-control float-right"
                                                    style={{width: "140px", marginRight: "20px"}}
                                                    placeholder="게시글 ID"
                                                    value={insightId}
                                                    onChange={(e) => {
                                                        searchParams.set("page", "1");
                                                        searchParams.set("insightId", e.target.value);
                                                        setSearchParams(searchParams);
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            e.preventDefault();
                                                            search();
                                                        }
                                                    }}
                                                />

                                                <label className="col-sm-auto col-form-label" style={{marginLeft: "10px"}}>회원 ID</label>
                                                <input
                                                    type="text"
                                                    className="form-control float-right"
                                                    style={{width: "140px", marginRight: "20px"}}
                                                    placeholder="회원 ID"
                                                    value={memberId}
                                                    onChange={(e) => {
                                                        searchParams.set("page", "1");
                                                        searchParams.set("memberId", e.target.value);
                                                        setSearchParams(searchParams);
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            e.preventDefault();
                                                            search();
                                                        }
                                                    }}
                                                />

                                                <button
                                                    type="button"
                                                    className="btn btn-info float-right"
                                                    style={{width: "80px", marginRight: "10px"}}
                                                    onClick={search}
                                                >
                                                    검색
                                                </button>
                                            </div>
                                        </div>

                                        <div className="card-body table-responsive p-0" style={{marginTop: "20px"}}>
                                            <table className="table table-hover text-nowrap" style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>숨김ID</th>
                                                    <th>게시글</th>
                                                    <th>회원</th>
                                                    <th>숨김일</th>
                                                    <th>관리</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {results && results.map(item => (
                                                    <tr key={item.hideId}>
                                                        <td>{item.hideId}</td>
                                                        <td>
                                                            <div>
                                                                <Link to={`/page/insights/detail?id=${item.insightId}`} target="_blank" rel="noopener noreferrer">
                                                                    #{item.insightId}: {item.insightTitle}
                                                                </Link>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <a
                                                                    href={`/page/users/detail?userId=${item.memberId}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    {item.memberId}: {item.memberNickname || "-"}
                                                                </a>
                                                            </div>
                                                        </td>
                                                        <td>{formatDate(item.createdAt)}</td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-danger btn-sm"
                                                                onClick={() => removeHide(item.hideId)}
                                                            >
                                                                숨김 해제
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {pager && <Pagination pager={pager} setPage={setPage} />}
                    </section>
                </div>
            </div>
        </div>
    );
}
